import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { of, Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { showAnimation } from 'src/animations';
import { PaginationResponse } from 'src/app/classes';
import { DoubletSuggestion } from '../../../classes';
import { DOUBLET_PROVIDER_SERVICE, IDoubletProviderService } from '../../../interfaces';

@Component({
  selector: 'app-doublet-checker',
  templateUrl: './doublet-checker.component.html',
  styleUrls: ['./doublet-checker.component.css'],
  animations: [ showAnimation ]
})
export class DoubletCheckerComponent implements OnInit, OnDestroy {

  total: number = 0;
  doublets: DoubletSuggestion[] = [];

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(DOUBLET_PROVIDER_SERVICE) public service: IDoubletProviderService
  ) { }

  loadMore(){
    
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.service.doublets$.subscribe((response: PaginationResponse<DoubletSuggestion[]>) => {
        this.doublets = response.content;
        this.total = response.totalItems;
      })
    ]);
  }

}
